import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/types'
import type { HardwareStatCardKey } from './hardware-statistics-cards.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    totalTerminals: { default: 0 },
    todayChangedTerminals: { default: 0 }
  },
  emits: ["statClick"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()

const emit = __emit

const props = __props

const statisticsItems = computed((): StatisticsCardItem[] => [
  {
    label: t('terminalHardware.terminalCount'),
    value: props.totalTerminals,
    span: 12,
    /** 与终端管理「全网数量」一致：始终可打开全量列表（含 0 台） */
    clickable: true,
    events: {
      click: () => emit('statClick', 'total')
    }
  },
  {
    label: t('terminalHardware.todayChangedTerminals'),
    value: props.todayChangedTerminals,
    span: 12,
    clickable: props.todayChangedTerminals > 0,
    events: {
      click: () => {
        if (props.todayChangedTerminals <= 0) return
        emit('statClick', 'todayChanged')
      }
    }
  }
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})